export default __webpack_public_path__ + "static/media/logo-growyx-v2.09306b59.svg";